// Dictionary module - loads the SOWPODS word list
// This file is loaded dynamically to avoid bundling the large word list inline

let VALID_WORDS = null;
let loadPromise = null;

// Load dictionary from original file
async function loadDictionary() {
    if (VALID_WORDS) return VALID_WORDS;

    if (loadPromise) return loadPromise;

    loadPromise = (async () => {
        try {
            // Dynamically import the original dictionary
            // In production this will be bundled, in dev it will be loaded from the original location
            const response = await fetch('/dictionary.txt');
            if (!response.ok) {
                throw new Error('Failed to load dictionary');
            }
            const text = await response.text();
            const words = text.trim().split('\n').map(w => w.trim().toUpperCase());
            VALID_WORDS = new Set(words);
            console.log(`Dictionary loaded: ${VALID_WORDS.size} words`);
            return VALID_WORDS;
        } catch (error) {
            console.error('Failed to load dictionary:', error);
            // Fall back to empty set - game will still work but all words invalid
            VALID_WORDS = new Set();
            return VALID_WORDS;
        }
    })();

    return loadPromise;
}

// Check if a word is valid
export function isValidWord(word) {
    if (!VALID_WORDS) {
        console.warn('Dictionary not yet loaded, assuming word is valid');
        return true;
    }
    return VALID_WORDS.has(word.toUpperCase());
}

// Initialize dictionary - call this at app startup
export async function initDictionary() {
    await loadDictionary();
}

// Export for use in other modules
export { VALID_WORDS };
